<template>
    <div>
        <b-form @submit.prevent="onHandleSubmitStorePotencialRisk" data-vv-scope="formPotencialRisk">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Titulo <span class="text-danger">*</span></label>
                        <b-form-input v-model="potencialRisk.title" type="text" class="form-control" name="title"
                            v-validate="'required'" data-vv-as=" " />
                        <span class="text-danger small" v-text="errors.first('formPotencialRisk.title')" />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-row>
                        <b-col md="5">
                            <b-form-group>
                                <label>Color del texto <span class="text-danger">*</span></label>
                                <b-input type="color" class="colors-item" v-model="potencialRisk.color" />
                            </b-form-group>
                            <b-form-group>
                                <label>Color del fondo <span class="text-danger">*</span></label>
                                <b-input type="color" class="colors-item" v-model="potencialRisk.background" />
                            </b-form-group>
                        </b-col>
                        <b-col md="7">
                            <span>Visualización del riesgo</span>
                            <div class="preview-risk mt-2" :style="`background-color: ${potencialRisk.background}; color: ${potencialRisk.color}`">
                                RIESGO POTENCIAL {{ potencialRisk.title }}
                            </div>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col md="12" class="mt-3">
                    <b-form-group>
                        <label>Seleccionar pictogramas</label>
                        <b-row class="flex-wrap">
                            <b-col class="mb-1" v-for="(pictogram, index) in activePictograms" :key="index" cols="3"
                                md="3" lg="3">
                                <div @click="onHandleTogglePictogram(sga_pictogram_ids, pictogram)"
                                    :class="getPictogramClass(pictogram.id, sga_pictogram_ids)">
                                    <b-img name="sga_pictogram_ids"
                                        v-model="potencialRisk.sga_pictogram_ids" :src="pictogram.image" :alt="pictogram.name"
                                        style="max-width: 55px; max-height: 55px;"></b-img>
                                    <small>{{ pictogram.name }}</small>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="onHandleCancelProcess()">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
    name: 'FormRulesPictograms',

    data() {
        return {
            sga_pictogram_ids: []
        };
    },

    computed: {

        ...mapState('sgaPictograms', ['activePictograms']),
        ...mapState('potencialRisks', [
            'action',
            'potencialRisk',
            'colorsBackground',
            'colorsText',
            'filter'
        ]),

    },

    mounted() {
        const pictogramas = [...this.potencialRisk.sga_pictogram_ids];

        this.activePictograms.map(pictogram => {
            const apply = pictogramas.find(x => x === pictogram.id);
            if (apply) this.onHandleTogglePictogram(this.sga_pictogram_ids, pictogram)
        })
    },

    methods: {

        ...mapActions('potencialRisks', [
            'storePotencialRisk',
            'updatePotencialRisk',
            'getPaginatePotencialRisks'
        ]),

        ...mapMutations('potencialRisks', [
            'setActionToForm',
            'setPotencialRisk',
            'resetPotencialRisk'
        ]),

        getPictogramClass(id, data) {
            return data.some(p => p.id === id) ? `base-pictogram selected` : 'base-pictogram';
        },

        onHandleTogglePictogram(data, pictogram) {
            const index = data.indexOf(pictogram);
            (index === -1) ? data.push(pictogram) : data.splice(index, 1);

            this.setPotencialRisk({ ...this.potencialRisk, sga_pictogram_ids: data.map(x => x.id) });
        },

        onHandleCancelProcess() {
            this.setActionToForm('CREATE')
            this.resetPotencialRisk();
            this.$bvModal.hide('modal-create-potencial-risk');
        },

        onHandleSelectColor(type, color) {
            this.setPotencialRisk({ ...this.potencialRisk, [type]: color });
        },

        async onHandleSubmitStorePotencialRisk() {

            const isValid = await this.$validator.validateAll('formPotencialRisk');
            if (!isValid) return;

            let response;

            if (this.action === 'CREATE') response = this.storePotencialRisk(this.potencialRisk);
            else response = this.updatePotencialRisk(this.potencialRisk);

            response.then(async () => {
                this.onHandleCancelProcess()
                await this.getPaginatePotencialRisks(this.filter);
            })
        }

    }
}
</script>

<style scoped>
.base-pictogram {
    cursor: pointer;
    background-color: white !important;
    border: 2px dashed #e1e3e1;
    border-radius: 4px;
    padding: 8px;
    width: 120px;
    height: 100px;
    min-height: 100px;
    text-align: center;
    line-height: 1.1;
    filter: grayscale(1);
    display: table-cell;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.selected {
    filter: grayscale(0);
    border: 2px solid #e1e3e1;
}

.base-pictogram small {
    font-size: 8px !important;
    color: #656565;
    text-transform: uppercase;
    display: block;
    margin-top: 6px;
}

.selected small {
    color: #f86c6b;
    font-weight: bold;
}

.preview-risk {
    width: 100%;
    height: 80%;
    border: 1px solid #e1e3e1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
}

</style>
